import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/media';

interface NewsPreviewProps {
  items: NewsItem[];
}

export default function NewsPreview({ items }: NewsPreviewProps) {
  return (
    <div className="rounded-lg border border-background-200/70 bg-background-100 p-4 md:p-6">
      <ul className="divide-y divide-background-200/70">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              to={`/news/${item.id}`}
              className="group flex cursor-pointer items-center gap-4 py-4 first:pt-0 last:pb-0"
            >
              <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-20 md:w-32">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} - 黄色影视资讯`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-accent-900">{item.category}</span>
                  <span>{item.date}</span>
                </div>
                <h3 className="mt-1.5 truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-500 md:text-base">
                  {item.title}
                </h3>
                <p className="mt-1 line-clamp-1 text-xs text-foreground-500 md:line-clamp-2">{item.summary}</p>
              </div>
              <i className="ri-arrow-right-s-line hidden shrink-0 text-xl text-foreground-500 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-500 sm:block"></i>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}